{
  "name": "argocd-mcp",
  "version": "0.2.0",
  "description": "Argo CD MCP Server",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/akuity/argocd-mcp.git"
  },
  "keywords": [
    "mcp",
    "argocd",
    "argocd-mcp",
    "argocd-mcp-server",
    "argo-cd",
    "argo-cd-mcp",
    "argo-cd-mcp-server",
    "cicd",
    "cicd-mcp",
    "cicd-mcp-server",
    "gitops",
    "gitops-mcp",
    "gitops-mcp-server",
    "kubernetes",
    "kubernetes-mcp",
    "kubernetes-mcp-server"
  ],
  "main": "dist/index.js",
  "type": "module",
  "bin": {
    "argocd-mcp": "dist/index.js"
  },
  "files": [
    "dist",
    "images",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "dev": "tsx watch src/index.ts http",
    "dev-sse": "tsx watch src/index.ts sse",
    "lint": "eslint src/**/*.ts --no-warn-ignored",
    "lint:fix": "eslint src/**/*.ts --fix",
    "build": "tsup",
    "build:watch": "tsup --watch",
    "generate-types": "dtsgen -c dtsgen.json -o src/types/argocd.d.ts swagger.json",
    "prepare": "npm run build"
  },
  "author": "Akuity, Inc.",
  "license": "Apache-2.0",
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.10.1",
    "dotenv": "^16.5.0",
    "express": "^5.1.0",
    "pino": "^9.6.0",
    "yargs": "^17.7.2",
    "zod": "^3.24.3"
  },
  "devDependencies": {
    "@dtsgenerator/replace-namespace": "^1.7.0",
    "@eslint/js": "^9.25.0",
    "@types/express": "^5.0.1",
    "@types/node": "^22.14.1",
    "@types/yargs": "^17.0.33",
    "dtsgenerator": "^3.19.2",
    "eslint": "^9.25.0",
    "eslint-config-prettier": "^10.1.2",
    "eslint-plugin-prettier": "^5.2.6",
    "prettier": "3.5.3",
    "tsup": "^8.4.0",
    "tsx": "^4.19.3",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.30.1"
  }
}
